import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./NavBar.css";

export const NavBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showButton, setShowButton] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navItems = [
    { id: "home", label: "Home" },
    { id: "services", label: "Services" },
    { id: "reviews", label: "Reviews" },
    { id: "about", label: "About" },
    { id: "service-areas", label: "Service Areas" },
    { id: "pricing", label: "Pricing" },
    { id: "contact", label: "Contact" }
  ];

  useEffect(() => {
    const checkVisibility = () => {
      if (location.pathname !== "/") {
        setShowButton(true);
      } else {
        setShowButton(window.scrollY > 500);
      }
    };

    window.addEventListener("scroll", checkVisibility);
    checkVisibility();

    return () => window.removeEventListener("scroll", checkVisibility);
  }, [location]);

  const handleNavigation = (id) => {
    setMenuOpen(false);
    const scrollToElement = (elementId) => {
      const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const headerOffset = 140; // Adjust based on your navbar height

      const attemptScroll = (retriesLeft = 8) => {
        const el = document.getElementById(elementId);
        if (el) {
          const elementPosition = el.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: prefersReducedMotion ? "auto" : "smooth"
          });
          return;
        }

        if (retriesLeft === 8) {
          window.dispatchEvent(new CustomEvent("reveal-section", { detail: { id: elementId } }));
        }

        if (retriesLeft > 0) {
          window.setTimeout(() => attemptScroll(retriesLeft - 1), 50);
        }
      };

      attemptScroll();
    };

    if (location.pathname === "/") {
      scrollToElement(id);
    } else {
      navigate("/");
      // Wait for navigation to complete then scroll
      setTimeout(() => {
        scrollToElement(id);
      }, 100);
    }
  };

  return (
    <nav className="navbar" aria-label="Primary">
      <div className="navbar-container">
        <button
          className="navbar-logo"
          onClick={() => handleNavigation("home")}
          type="button"
          aria-label="Go to top of homepage"
        >
          <img src="/logo.webp" alt="" aria-hidden="true" />
        </button>
        <button
          className={`navbar-hamburger ${menuOpen ? "open" : ""}`}
          type="button"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
          aria-controls="primary-navigation-menu"
        >
          <span />
          <span />
          <span />
        </button>
        <ul id="primary-navigation-menu" className={`navbar-menu ${menuOpen ? "open" : ""}`}>
          {navItems.map((item) => (
            <li key={item.id}>
              <button type="button" onClick={() => handleNavigation(item.id)}>
                {item.label}
              </button>
            </li>
          ))}
        </ul>
        <div className={`navbar-cta ${showButton ? "visible" : ""}`}>
          <button type="button" onClick={() => handleNavigation("contact")}>Schedule Service</button>
        </div>
      </div>
    </nav>
  );
};
